import * as React from 'react'

import { cn } from '#/shared/lib/utils'

export type LabelSize = 'default' | 'sm'

interface LabelProps extends React.LabelHTMLAttributes<HTMLLabelElement> {
  size?: LabelSize
}

const DEFAULT_LABEL_FONT_SIZE = '11px'

const sizeClasses: Record<LabelSize, string> = {
  default: 'text-gray-500',
  sm: 'text-xs text-gray-500',
}

const Label = React.forwardRef<HTMLLabelElement, LabelProps>(
  ({ className, size = 'default', style, ...props }, ref) => (
    <label
      ref={ref}
      className={cn(sizeClasses[size], className)}
      style={size === 'default' ? { fontSize: DEFAULT_LABEL_FONT_SIZE, ...style } : style}
      {...props}
    />
  ),
)
Label.displayName = 'Label'

export { Label }
export type { LabelProps }
